import { informNewVersion } from './actions/artisan/dialogs';

export default function register() {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  const swUrl = 'oneSignal/OneSignalSDKWorker.js';

  fetch(swUrl).then((response) => {
    if (
      response.status === 404 ||
      response.headers.get('content-type').indexOf('javascript') === -1
    ) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister().then(() => {
          window.location.reload(true);
        });
      });
    } else {
      navigator.serviceWorker.ready.then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          installingWorker.onstatechange = () => {
            if (
              installingWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              informNewVersion();
              setTimeout(() => window.location.reload(true), 2000);
            }
          };
        };
      });
    }
  }).catch((e) => {
    console.error('OneSignal SW health-check failed:', e.message || e);
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
